import { Fragment } from "react"
import { Outlet } from "react-router-dom"

const OrganizationWrapper = () => {

    return (
        <Fragment>
           <Outlet/>
        </Fragment>
    )
}

export default OrganizationWrapper